import { PRIVATE_HTTP as http } from "../http-common";

const updateProfile = async (body: any) => {
  return http().put("/api/v4/users/", body);
};

const changePassword = async (body: any) => {
  return http().put("/api/v4/users/password", body);
};

export { updateProfile, changePassword };
